<template>
  <div class="app-main-top-header">
    <div class="header">
      <router-link
        key="expand"
        to="/"
      >
      <div class="header__title">
        <img
          src="@/assets/images/logo-viet-nam.png"
          alt=""
        >
        <h1>PHẦN MỀM QUẢN LÝ DI SẢN</h1>
      </div>
    </router-link>
    <div class="header__menu-right">
      <span>Ngày {{ dayjs().format('DD/MM/YYYY') }}</span>
      <div
        style="display: flex; align-items: center;"
        class="action-logout"
        @click="() => logout()"
      >
        <span>Đăng xuất</span>
        <img
          src="@/assets/images/icon-logout.png"
          alt=""
        >
      </div>
    </div>
    </div>
    <Breadcrumb
      id="breadcrumb-container"
      class="breadcrumb-container"
    />
    <div class="navbar px-xl">
      <div class="navbar__left">
        <Menus />
      </div>
      <RightMenus />
    </div>
  </div>
</template>

<script>
import Menus from './Menus.vue';
import RightMenus from './RightMenus.vue';
import dayjs from 'dayjs'
import authServices from "@/services/auth";
import Breadcrumb from "../Breadcumb/index";

export default {
  name: 'Navbar',
  components: {
    Menus,
    RightMenus,
    Breadcrumb
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    dayjs,

    logout() {
      authServices.logout();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-main-top-header {
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 40px;
    background-color: #E23C3C;
    color: #ffffff;
    &__title {
      display: flex;
      align-items: center;
      gap: 12px;
      img {
        width: 40px;
        object-fit: contain;
      }
      h1 {
        color: #ffffff;
      }
    }
    &__menu-right {
      display: flex;
      align-items: center;
      gap: 24px;
      img {
        margin-left: 4px;
      }
      .action-logout {
        cursor: pointer;
      }
    }
  }
  .navbar {
    height: 56px;
    overflow: hidden;
    position: relative;
    background: #ffcd12;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    display: flex;
    align-items: center;
    justify-content: space-between;
    &__left {
      display: flex;
      align-items: center;
    }
  }
}

</style>
